import { Space, Tag } from 'antd';
import { formatDate, formatDateTime, formateMdnNumber,formatCurrency, getFormatedDate, getFormatedDateWithSeperator, formatDateTime2 } from '../../../src/components/Common/Extensions';

export const data = {

    PostpaidWireless: [
        {
            title: '',
            dataIndex: 'wirelessId',
            className: "custom-grid-hide-col",
        },
        //{
        //    title: 'Status',
        //    dataIndex: 'statusCol',
        //    className: "width130 textCenter ",
        //    sorter: (a, b) => {
        //        a = a.statusCol != null ? a.statusCol.toString() : "";
        //        b = b.statusCol != null ? b.statusCol.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

        {
            title: 'Phone #',
            dataIndex: 'mDN',
            className: "width140",
            sorter: (a, b) => {
                a = a.mDN != null ? a.mDN.toString() : "";
                b = b.mDN != null ? b.mDN.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'ICC/SIM',
            dataIndex: 'iCC',
            className: "width140",
            sorter: (a, b) => {
                a = a.iCC != null ? a.iCC.toString() : "";
                b = b.iCC != null ? b.iCC.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'username',
            className: "width120",
            sorter: (a, b) => {
                a = a.username != null ? a.username.toString() : "";
                b = b.username != null ? b.username.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Plan Name',
            dataIndex: 'planDisplayName',
            className: "width140",
            sorter: (a, b) => {
                a = a.planDisplayName != null ? a.planDisplayName.toString() : "";
                b = b.planDisplayName != null ? b.planDisplayName.toString() : "";
                return a.localeCompare(b);
            },
            //render: text => {
            //    if (text == null || text.trim() === '') {
            //        return '';
            //    }
            //    return text.includes('Figgers Text Only') ? 'Figgers Text Only' : text;
            //}
        },
        {
            title: 'Box Floor',
            dataIndex: 'boxFloor',
            className: "width100",
            sorter: (a, b) => {
                a = a.boxFloor != null ? a.boxFloor.toString() : "";
                b = b.boxFloor != null ? b.boxFloor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Port',
            dataIndex: 'port',
            className: "width50",
            sorter: (a, b) => {
                a = a.port != null ? a.port.toString() : "";
                b = b.port != null ? b.boxFloor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Activated on", 
            dataIndex: "activationDate",
            className: "width180",
            sorter: (a, b) => {
                a = a.activationDate != null ? a.activationDate.toString() : "";
                b = b.activationDate != null ? b.activationDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);

            }
        },

        {
            //ESN>Equipment Serial Number
            title: 'Device',
            dataIndex: 'eSN',
            className: "width140",
            sorter: (a, b) => {
                a = a.eSN != null ? a.eSN.toString() : "";
                b = b.eSN != null ? b.eSN.toString() : "";
                return a.localeCompare(b);
            },
        },

        // {
        //     title: 'Notes',
        //     dataIndex: 'customNoteHTML',
        //     className: " textCenter",
        //     sorter: (a, b) => {
        //         a = a.customNoteHTML != null ? a.customNoteHTML.toString() : "";
        //         b = b.customNoteHTML != null ? b.customNoteHTML.toString() : "";
        //         return a.localeCompare(b);
        //     },
        // },
        {
            title: 'Actions',
            dataIndex: 'prepaidAction',
            fixed: "right",
            className: "width140 textCenter",
        },

    ],
    PostpaidWirelessInactive: [
        {
            title: '',
            dataIndex: 'wirelessId',
            className: "custom-grid-hide-col",
        },
        //{
        //    title: 'Status',
        //    dataIndex: 'statusCol',
        //    className: "width130 textCenter ",
        //    sorter: (a, b) => {
        //        a = a.statusCol != null ? a.statusCol.toString() : "";
        //        b = b.statusCol != null ? b.statusCol.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

        {
            title: 'Phone #',
            dataIndex: 'mDN',
            className: "width140",
            sorter: (a, b) => {
                a = a.mDN != null ? a.mDN.toString() : "";
                b = b.mDN != null ? b.mDN.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'ICC/SIM',
            dataIndex: 'iCC',
            className: "width140",
            sorter: (a, b) => {
                a = a.iCC != null ? a.iCC.toString() : "";
                b = b.iCC != null ? b.iCC.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'username',
            className: "width120",
            sorter: (a, b) => {
                a = a.username != null ? a.username.toString() : "";
                b = b.username != null ? b.username.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Plan Name',
            dataIndex: 'planDisplayName',
            className: "width140",
            sorter: (a, b) => {
                a = a.planDisplayName != null ? a.planDisplayName.toString() : "";
                b = b.planDisplayName != null ? b.planDisplayName.toString() : "";
                return a.localeCompare(b);
            },
            //render: text => {
            //    if (text == null || text.trim() === '') {
            //        return '';
            //    }
            //    return text.includes('Figgers Text Only') ? 'Figgers Text Only' : text;
            //}
        },
        {
            title: 'Box Floor',
            dataIndex: 'boxFloor',
            className: "width100",
            sorter: (a, b) => {
                a = a.boxFloor != null ? a.boxFloor.toString() : "";
                b = b.boxFloor != null ? b.boxFloor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Port',
            dataIndex: 'port',
            className: "width50",
            sorter: (a, b) => {
                a = a.port != null ? a.port.toString() : "";
                b = b.port != null ? b.boxFloor.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Operation Date",
            dataIndex: "createDate",
            className: "width180",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);

            }
        },
        {
            title: 'Device',
            dataIndex: 'eSN',
            className: "width140",
            sorter: (a, b) => {
                a = a.eSN != null ? a.eSN.toString() : "";
                b = b.eSN != null ? b.eSN.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Notes',
            dataIndex: 'customNoteHTML',
            className: " textCenter",
            sorter: (a, b) => {
                a = a.customNoteHTML != null ? a.customNoteHTML.toString() : "";
                b = b.customNoteHTML != null ? b.customNoteHTML.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Actions',
            dataIndex: 'prepaidAction',
            fixed: "right",
            className: "width140 textCenter",
        },

    ],
    PrepaidWireless: [
        {
            title: '',
            dataIndex: 'wirelessId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Status',
            dataIndex: 'statusCol',
            className: "width130 textCenter",
            sorter: (a, b) => {
                a = a.statusCol != null ? a.statusCol.toString() : "";
                b = b.statusCol != null ? b.statusCol.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Phone #',
            dataIndex: 'mDN',
            className: "width130",
            sorter: (a, b) => {
                a = a.mDN != null ? a.mDN.toString() : "";
                b = b.mDN != null ? b.mDN.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'ICC/SIM',
            dataIndex: 'iCC',
            className: "width140",
            sorter: (a, b) => {
                a = a.iCC != null ? a.iCC.toString() : "";
                b = b.iCC != null ? b.iCC.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Name',
            dataIndex: 'username',
            className: "width120",
            sorter: (a, b) => {
                a = a.username != null ? a.username.toString() : "";
                b = b.username != null ? b.username.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Plan Name',
            dataIndex: 'primaryPlanName',
            className: "width100",
            sorter: (a, b) => {
                a = a.primaryPlanName != null ? a.primaryPlanName.toString() : "";
                b = b.primaryPlanName != null ? b.primaryPlanName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Activated on",
            dataIndex: "activationDate",
            className: "width140",
            sorter: (a, b) => {
                a = a.activationDate != null ? a.activationDate.toString() : "";
                b = b.activationDate != null ? b.activationDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return getFormatedDateWithSeperator(text);

            }
        },

        {
            //ESN>Equipment Serial Number
            title: 'Device',
            dataIndex: 'eSN',
            className: "width140",
            sorter: (a, b) => {
                a = a.eSN != null ? a.eSN.toString() : "";
                b = b.eSN != null ? b.eSN.toString() : "";
                return a.localeCompare(b);
            },
        },

        //{
        //    title: 'Forwarded to',
        //    dataIndex: 'Forwardedto',
        //    className: "width130",
        //    sorter: (a, b) => {
        //        a = a.Forwardedto != null ? a.Forwardedto.toString() : "";
        //        b = b.Forwardedto != null ? b.Forwardedto.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

        {
            title: 'Notes',
            dataIndex: 'customNoteHTML',
            className: "width100",
            sorter: (a, b) => {
                a = a.customNoteHTML != null ? a.customNoteHTML.toString() : "";
                b = b.customNoteHTML != null ? b.customNoteHTML.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Actions',
            dataIndex: 'prepaidAction',
            fixed: "right",
            className: "width140 textCenter",
        },

    ],
    PrepaidPackages: [
        {
            title: '',
            dataIndex: 'packageId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            className: "width80",
            sorter: (a, b) => {
                a = a.mDN != null ? a.mDN.toString() : "";
                b = b.mDN != null ? b.mDN.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formateMdnNumber(text);
            }
        },
        {
            title: 'Name',
            dataIndex: 'planDisplayName',
            className: "width100",
            sorter: (a, b) => {
                a = a.planDisplayName != null ? a.planDisplayName.toString() : "";
                b = b.planDisplayName != null ? b.planDisplayName.toString() : "";
                return a.localeCompare(b);
            },
            //render: text => {
            //    if (text == null || text.trim() === '') {
            //        return '';
            //    }
            //    return text.includes('Figgers Text Only') ? 'Figgers Text Only' : text;
            //}
        },

        {
            title: 'Category',
            dataIndex: 'category',
            className: "width80",
            sorter: (a, b) => {
                a = a.category != null ? a.category.toString() : "";
                b = b.category != null ? b.category.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Behavior',
            dataIndex: 'behavior',
            className: "width140",
            sorter: (a, b) => {
                a = a.behavior != null ? a.behavior.toString() : "";
                b = b.behavior != null ? b.behavior.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Usage Type',
            dataIndex: 'usageType',
            className: "width120",
            sorter: (a, b) => {
                a = a.usageType != null ? a.usageType.toString() : "";
                b = b.usageType != null ? b.usageType.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    
    UserDetails: [
        {
            title: '',
            dataIndex: 'userId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Date /Time',
            dataIndex: 'Sr',
            className: "width140",
            sorter: (a, b) => {
                a = a.date != null ? a.date.toString() : "";
                b = b.date != null ? b.date.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Type',
            dataIndex: 'usageType',
            className: "width80",
            sorter: (a, b) => {
                a = a.type != null ? a.type.toString() : "";
                b = b.type != null ? b.type.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Destination Number',
            dataIndex: 'sim',
            className: "width140",
            sorter: (a, b) => {
                a = a.destinationNumber != null ? a.destinationNumber.toString() : "";
                b = b.destinationNumber != null ? b.destinationNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Destination Operator',
            dataIndex: 'status',
            className: "width120",
            sorter: (a, b) => {
                a = a.destinationOperator != null ? a.destinationOperator.toString() : "";
                b = b.destinationOperator != null ? b.destinationOperator.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Duration",
            dataIndex: "name",
            className: "width130",
            sorter: (a, b) => {
                a = a.duration != null ? a.duration.toString() : "";
                b = b.duration != null ? b.duration.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Amount ($) ',
            dataIndex: 'amount',
            className: "width120",
            sorter: (a, b) => {
                a = a.amount != null ? a.amount.toString() : "";
                b = b.amount != null ? b.amount.toString() : "";
                return a.localeCompare(b);
            },
        },

        {
            title: 'Discount ($) ',
            dataIndex: 'discount',
            className: "width150",
            sorter: (a, b) => {
                a = a.discount != null ? a.discount.toString() : "";
                b = b.discount != null ? b.discount.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Net Amount ($)',
            dataIndex: 'netAmount',
            className: "width150",
            sorter: (a, b) => {
                a = a.netAmount != null ? a.netAmount.toString() : "";
                b = b.netAmount != null ? b.netAmount.toString() : "";
                return a.localeCompare(b);
            },
        },

    ],
    SMSDetails: [
        {
            title: '',
            dataIndex: 'userId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Date /Time',
            dataIndex: 'column3',
            className: "width140",
            sorter: (a, b) => {
                a = a.column3 != null ? a.column3.toString() : "";
                b = b.column3 != null ? b.column3.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'From Number',
            dataIndex: 'column1',
            className: "width140",
            sorter: (a, b) => {
                a = a.column1 != null ? a.column1.toString() : "";
                b = b.column1 != null ? b.column1.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'To Number',
            dataIndex: 'column2',
            className: "width140",
            sorter: (a, b) => {
                a = a.column2 != null ? a.column2.toString() : "";
                b = b.column2 != null ? b.column2.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: "Duration",
        //    dataIndex: "column4",
        //    className: "width130",
        //    sorter: (a, b) => {
        //        a = a.column4 != null ? a.column4.toString() : "";
        //        b = b.column4 != null ? b.column4.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Cost ($) ',
            dataIndex: 'column6',
            className: "width120",
            sorter: (a, b) => {
                a = a.column6 != null ? a.column6.toString() : "";
                b = b.column6 != null ? b.column6.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return "$" + text
            }
        },
        //{
        //    title: 'Call Plan ',
        //    dataIndex: 'column6',
        //    className: "width120",
        //    sorter: (a, b) => {
        //        a = a.column6 != null ? a.column6.toString() : "";
        //        b = b.column6 != null ? b.column6.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

    ],
    CallDetails: [
        {
            title: '',
            dataIndex: 'userId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Date /Time',
            dataIndex: 'column3',
            className: "width140",
            sorter: (a, b) => {
                a = a.column3 != null ? a.column3.toString() : "";
                b = b.column3 != null ? b.column3.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Type',
        //    dataIndex: 'column2',
        //    className: "width80",
        //    sorter: (a, b) => {
        //        a = a.column2 != null ? a.column2.toString() : "";
        //        b = b.column2 != null ? b.column2.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'From Number',
            dataIndex: 'column1',
            className: "width140",
            sorter: (a, b) => {
                a = a.column1 != null ? a.column1.toString() : "";
                b = b.column1 != null ? b.column1.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'To Number',
            dataIndex: 'column2',
            className: "width120",
            sorter: (a, b) => {
                a = a.column2 != null ? a.column2.toString() : "";
                b = b.column2 != null ? b.column2.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Duration",
            dataIndex: "column5",
            className: "width130",
            sorter: (a, b) => {
                a = a.column5 != null ? a.column5.toString() : "";
                b = b.column5 != null ? b.column5.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Cost ($) ',
            dataIndex: 'column6',
            className: "width120",
            sorter: (a, b) => {
                a = a.column6 != null ? a.column6.toString() : "";
                b = b.column6 != null ? b.column6.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return "$" + text
            }
        },
        {
            title: 'Data Used ',
            dataIndex: 'column8',
            className: "width120",
            sorter: (a, b) => {
                a = a.column8 != null ? a.column8.toString() : "";
                b = b.column8 != null ? b.column8.toString() : "";
                return a.localeCompare(b);
            },
        },

        //{
        //    title: 'Discount ($) ',
        //    dataIndex: 'discount',
        //    className: "width150",
        //    sorter: (a, b) => {
        //        a = a.discount != null ? a.discount.toString() : "";
        //        b = b.discount != null ? b.discount.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        //{
        //    title: 'Net Amount ($)',
        //    dataIndex: 'netAmount',
        //    className: "width150",
        //    sorter: (a, b) => {
        //        a = a.netAmount != null ? a.netAmount.toString() : "";
        //        b = b.netAmount != null ? b.netAmount.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

    ],

    DataDetails: [
        {
            title: '',
            dataIndex: 'userId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Date /Time',
            dataIndex: 'column3',
            className: "width140",
            sorter: (a, b) => {
                a = a.column3 != null ? a.column3.toString() : "";
                b = b.column3 != null ? b.column3.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Number',
            dataIndex: 'column1',
            className: "width80",
            sorter: (a, b) => {
                a = a.column1 != null ? a.column1.toString() : "";
                b = b.column1 != null ? b.column1.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Call To',
        //    dataIndex: 'column2',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.column2 != null ? a.column2.toString() : "";
        //        b = b.column2 != null ? b.column2.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: "Duration",
            dataIndex: "column5",
            className: "width130",
            sorter: (a, b) => {
                a = a.column5 != null ? a.column5.toString() : "";
                b = b.column5 != null ? b.column5.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Cost ($) ',
            dataIndex: 'column6',
            className: "width120",
            sorter: (a, b) => {
                a = a.column6 != null ? a.column6.toString() : "";
                b = b.column6 != null ? b.column6.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return "$" + text
            }
        },
        //{
        //    title: 'Call Plan ',
        //    dataIndex: 'column6',
        //    className: "width120",
        //    sorter: (a, b) => {
        //        a = a.column6 != null ? a.column6.toString() : "";
        //        b = b.column6 != null ? b.column6.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Data Used ',
            dataIndex: 'column8',
            className: "width120",
            sorter: (a, b) => {
                a = a.column8 != null ? a.column8.toString() : "";
                b = b.column8 != null ? b.column8.toString() : "";
                return a.localeCompare(b);
            },
        },

        //{
        //    title: 'Discount ($) ',
        //    dataIndex: 'discount',
        //    className: "width150",
        //    sorter: (a, b) => {
        //        a = a.discount != null ? a.discount.toString() : "";
        //        b = b.discount != null ? b.discount.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        //{
        //    title: 'Net Amount ($)',
        //    dataIndex: 'netAmount',
        //    className: "width150",
        //    sorter: (a, b) => {
        //        a = a.netAmount != null ? a.netAmount.toString() : "";
        //        b = b.netAmount != null ? b.netAmount.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},

    ],
    ActivityLog: [
        {
            title: '',
            dataIndex: 'userId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Session ID',
            dataIndex: 'sessionId',
            className: "width140",
            sorter: (a, b) => {
                a = a.date != null ? a.date.toString() : "";
                b = b.date != null ? b.date.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date/Time',
            dataIndex: 'activityDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.date != null ? a.date.toString() : "";
                b = b.date != null ? b.date.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Account #',
            dataIndex: 'accountNumber',
            className: "width120",
            sorter: (a, b) => {
                a = a.type != null ? a.type.toString() : "";
                b = b.type != null ? b.type.toString() : "";
                return a.localeCompare(b);
            },
          
        },
        {
            title: 'Phone #',
            dataIndex: 'mdnNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.destinationNumber != null ? a.destinationNumber.toString() : "";
                b = b.destinationNumber != null ? b.destinationNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'User',
            dataIndex: 'user',
            className: "width120",
            sorter: (a, b) => {
                a = a.destinationOperator != null ? a.destinationOperator.toString() : "";
                b = b.destinationOperator != null ? b.destinationOperator.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Activity",
            dataIndex: "details",
            className: "width130",
            sorter: (a, b) => {
                a = a.duration != null ? a.duration.toString() : "";
                b = b.duration != null ? b.duration.toString() : "";
                return a.localeCompare(b);
            },
        },


    ],
    AddNewSim: [
        {
            title: '',
            dataIndex: 'requestsId',
            className: "custom-grid-hide-col",
        },
        {
            title: 'Sr#',
            dataIndex: 'sr',
            className: "width140",
            sorter: (a, b) => {
                a = a.sr != null ? a.sr.toString() : "";
                b = b.sr != null ? b.sr.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Order Number',
            dataIndex: 'orderNumber',
            className: "width80",
            sorter: (a, b) => {
                a = a.orderNumber != null ? a.orderNumber.toString() : "";
                b = b.orderNumber != null ? b.orderNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Customer Information',
            dataIndex: 'customerInformation',
            className: "width140",
            sorter: (a, b) => {
                a = a.customerInformation != null ? a.customerInformation.toString() : "";
                b = b.customerInformation != null ? b.customerInformation.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Order Information',
            dataIndex: 'orderInformation',
            className: "width120",
            sorter: (a, b) => {
                a = a.orderInformation != null ? a.orderInformation.toString() : "";
                b = b.orderInformation != null ? b.orderInformation.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "Order Status",
            dataIndex: "orderStatus",
            className: "width130",
        },
        {
            title: 'Action',
            dataIndex: 'requestAction',
            fixed: "right",
            className: "width140 textCenter",
        },
    ],
    customerNotes : [
        {
            title: 'Note Date',
            dataIndex: 'noteDate',
            className: "width40",
            sorter: (a, b) => {
                a = a.noteDate != null ? a.noteDate.toString() : "";
                b = b.noteDate != null ? b.noteDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        
        {
            title: 'Entered By',
            dataIndex: 'userName',
            className: "width40",
            sorter: (a, b) => {
                a = a.userName != null ? a.userName.toString() : "";
                b = b.userName != null ? b.userName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Note',
            dataIndex: 'note',
            className: "width80",
            sorter: (a, b) => {
                a = a.note != null ? a.note.toString() : "";
                b = b.note != null ? b.note.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    usageDetailsData: [
        {
            title: 'Phone',
            dataIndex: 'mDN',
            className: "width40",
            sorter: (a, b) => {
                a = a.mDN != null ? a.mDN.toString() : "";
                b = b.mDN != null ? b.mDN.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: "🌐 Data(GB)",
            dataIndex: 'internetUsage',
            className: "width40",
            sorter: (a, b) => {
                a = a.internetUsage != null ? a.internetUsage.toString() : "";
                b = b.internetUsage != null ? b.internetUsage.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Voice Minutes',
            dataIndex: 'voiceMinutes',
            className: "width40",
            sorter: (a, b) => {
                a = a.voiceMinutes != null ? a.voiceMinutes.toString() : "";
                b = b.voiceMinutes != null ? b.voiceMinutes.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Text',
            dataIndex: 'sMSMessages',
            className: "width40",
            sorter: (a, b) => {
                a = a.sMSMessages != null ? a.sMSMessages.toString() : "";
                b = b.sMSMessages != null ? b.sMSMessages.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'International Minutes',
            dataIndex: 'roamingMinutes',
            className: "width40",
            sorter: (a, b) => {
                a = a.roamingMinutes != null ? a.roamingMinutes.toString() : "";
                b = b.roamingMinutes != null ? b.roamingMinutes.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    paymentHistory: [

        {
            title: 'Invoice #',
            dataIndex: 'id',
            className: "width100",
            sorter: (a, b) => {
                a = a.id != null ? a.id.toString() : "";
                b = b.id != null ? b.id.toString() : "";
                return a.localeCompare(b);
            }
        },
        {
            title: 'Amount',
            dataIndex: 'formattedAmount',
            className: "width80",
            sorter: (a, b) => {
                a = a.formattedAmount != null ? a.formattedAmount.toString() : "";
                b = b.formattedAmount != null ? b.formattedAmount.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatCurrency(text);
            }
        },
        {
            title: 'Payment Date',
            dataIndex: 'date',
            className: "width140",
            sorter: (a, b) => {
                a = a.date != null ? a.date.toString() : "";
                b = b.date != null ? b.date.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
   
        {
            title: 'Description',
            dataIndex: 'description',
            className: "width80",
            sorter: (a, b) => {
                a = a.description != null ? a.description.toString() : "";
                b = b.description != null ? b.description.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Receipt',
            dataIndex: 'receiptHTMLAction',
            fixed: "right",
            className: "width100 textCenter",
        }
    ],
    rechageHistory: [
        {
            title: 'Sr #',
            dataIndex: 'srNo',
            className: "width40",
            sorter: (a, b) => {
                a = a.srNo != null ? a.srNo.toString() : "";
                b = b.srNo != null ? b.srNo.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Account #',
            dataIndex: 'Account',
            className: "width80",
            sorter: (a, b) => {
                a = a.Account != null ? a.Account.toString() : "";
                b = b.Account != null ? b.Account.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Package',
            dataIndex: 'Package',
            className: "width80",
            sorter: (a, b) => {
                a = a.Package != null ? a.Package.toString() : "";
                b = b.Package != null ? b.Package.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Expiry Date',
            dataIndex: 'ExpiryDate',
            className: "width80",
            sorter: (a, b) => {
                a = a.ExpiryDate != null ? a.ExpiryDate.toString() : "";
                b = b.ExpiryDate != null ? b.ExpiryDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Recharge Date',
            dataIndex: 'RechargeDate',
            className: "width80",
            sorter: (a, b) => {
                a = a.RechargeDate != null ? a.RechargeDate.toString() : "";
                b = b.RechargeDate != null ? b.RechargeDate.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Amount',
            dataIndex: 'Amount',
            className: "width80",
            sorter: (a, b) => {
                a = a.Amount != null ? a.Amount.toString() : "";
                b = b.Amount != null ? b.Amount.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    addressBook: [
        //{
        //    title: 'Sr #',
        //    dataIndex: 'srNo',
        //    className: "width40",
        //    sorter: (a, b) => {
        //        a = a.srNo != null ? a.srNo.toString() : "";
        //        b = b.srNo != null ? b.srNo.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Name',
            dataIndex: 'firstName',
            className: "width80",
            sorter: (a, b) => {
                a = a.name != null ? a.name.toString() : "";
                b = b.name != null ? b.name.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Number',
            dataIndex: 'phoneNumber',
            className: "width80",
            sorter: (a, b) => {
                a = a.number != null ? a.number.toString() : "";
                b = b.number != null ? b.number.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
            className: "width80",
            sorter: (a, b) => {
                a = a.email != null ? a.email.toString() : "";
                b = b.email != null ? b.email.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Favorite',
        //    dataIndex: 'status',
        //    className: "width80",
        //    sorter: (a, b) => {
        //        a = a.status != null ? a.status.toString() : "";
        //        b = b.status != null ? b.status.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Actions',
            dataIndex: 'action',
            className: "width80",
            sorter: (a, b) => {
                a = a.Actions != null ? a.Actions.toString() : "";
                b = b.Actions != null ? b.Actions.toString() : "";
                return a.localeCompare(b);
            },
        },
    ],
    roles: [
        {
            title: 'Role Name',
            dataIndex: 'roleName',
            className: "width140",
            sorter: (a, b) => {
                a = a.roleName != null ? a.roleName.toString() : "";
                b = b.roleName != null ? b.roleName.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Description',
            dataIndex: 'roleDescription',
            className: "width140",
            sorter: (a, b) => {
                a = a.roleDescription != null ? a.roleDescription.toString() : "";
                b = b.roleDescription != null ? b.roleDescription.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Type',
            dataIndex: 'roleType',
            className: "width140",
            sorter: (a, b) => {
                a = a.roleType != null ? a.roleType.toString() : "";
                b = b.roleType != null ? b.roleType.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
        {
            //title: 'Actions',
            //dataIndex: 'commonAction',
            //className: "commonActionWidth",
            title: 'Actions',
            dataIndex: 'rolesAction',
            fixed: "right",
            className: "commonActionWidth width100 text-center",
        },
    ],
    users: [
        {
            dataIndex: 'corporateOwnerIdentifier',
            className: "width5",
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            className: "width140",
            sorter: (a, b) => {
                a = a.fullName != null ? a.fullName.toString() : "";
                b = b.fullName != null ? b.fullName.toString() : "";
                return a.localeCompare(b);
            },

        },
        {
            title: 'Email Address',
            dataIndex: 'emailAddress',
            className: "width140",
            sorter: (a, b) => {
                a = a.emailAddress != null ? a.emailAddress.toString() : "";
                b = b.emailAddress != null ? b.emailAddress.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Phone',
            dataIndex: 'phoneNumber',
            className: "width140",
            sorter: (a, b) => {
                a = a.phoneNumber != null ? a.phoneNumber.toString() : "";
                b = b.phoneNumber != null ? b.phoneNumber.toString() : "";
                return a.localeCompare(b);
            },
        },
        {
            title: 'Role',
            dataIndex: 'roleName',
            className: "width140",
            sorter: (a, b) => {
                a = a.roleName != null ? a.roleName.toString() : "";
                b = b.roleName != null ? b.roleName.toString() : "";
                return a.localeCompare(b);
            },
        },
        //{
        //    title: 'Address',
        //    dataIndex: 'completeAddress',
        //    className: "width140",
        //    sorter: (a, b) => {
        //        a = a.completeAddress != null ? a.completeAddress.toString() : "";
        //        b = b.completeAddress != null ? b.completeAddress.toString() : "";
        //        return a.localeCompare(b);
        //    },
        //},
        {
            title: 'Date/Time',
            dataIndex: 'createDate',
            className: "width140",
            sorter: (a, b) => {
                a = a.createDate != null ? a.createDate.toString() : "";
                b = b.createDate != null ? b.createDate.toString() : "";
                return a.localeCompare(b);
            },
            render: text => {
                return formatDateTime(text);
            }
        },
        {
            title: 'Actions',
            dataIndex: 'userActions',
            fixed: "right",
            className: "commonActionWidth width100 text-center",

        },
       ],
    auditSessionsByDate: [
        {
            title: 'Login Time',
            dataIndex: 'loginTime',
            className: "width100",
            sorter: (a, b) => (a.loginTime || "").toString().localeCompare((b.loginTime || "").toString()),
        },
        {
            title: 'Logout Time',
            dataIndex: 'logoutTime',
            className: "width100",
            sorter: (a, b) => (a.logoutTime || "").toString().localeCompare((b.logoutTime || "").toString()),
        },
        {
            title: 'Admin User',
            dataIndex: 'adminHTML',
            className: "width180",
            sorter: (a, b) => (a.admin || "").toString().localeCompare((b.admin || "").toString()),
        },
        {
            title: 'Duration',
            dataIndex: 'duration',
            className: "width100",
            sorter: (a, b) => (a.duration || "").toString().localeCompare((b.duration || "").toString()),
        },
        {
            title: 'Activities',
            dataIndex: 'activitiesHTML',
            className: "width100 textCenter",
            sorter: (a, b) => (a.activities || 0) - (b.activities || 0),
        },
        {
            title: 'Device',
            dataIndex: 'deviceHTML',
            className: "width180",
            sorter: (a, b) => (a.device || "").toString().localeCompare((b.device || "").toString()),
        },
        {
            title: 'IP Address',
            dataIndex: 'ipAddress',
            className: "width140",
            sorter: (a, b) => (a.ipAddress || "").toString().localeCompare((b.ipAddress || "").toString()),
        },
    ],
    auditLineActivityHistory: [
        {
            title: 'Date/Time',
            dataIndex: 'dateTime',
            className: "width120",
            sorter: (a, b) => (a.activityDate || "").toString().localeCompare((b.activityDate || "").toString()),
        },
        {
            title: 'Activity',
            dataIndex: 'activityHTML',
            className: "width140",
            sorter: (a, b) => (a.activityLabel || "").toString().localeCompare((b.activityLabel || "").toString()),
        },
        {
            title: 'Line / ICCID',
            dataIndex: 'lineIccidHTML',
            className: "width140",
            sorter: (a, b) => (a.lineIccid || "").toString().localeCompare((b.lineIccid || "").toString()),
        },
        {
            title: 'MDN Change',
            dataIndex: 'mdnChangeHTML',
            className: "width150",
            sorter: (a, b) => (a.mdnChange || "").toString().localeCompare((b.mdnChange || "").toString()),
        },
        {
            title: 'ICCID Change',
            dataIndex: 'iccidChangeHTML',
            className: "width170",
            sorter: (a, b) => (a.iccidChange || "").toString().localeCompare((b.iccidChange || "").toString()),
        },
        {
            title: 'IMEI Change',
            dataIndex: 'imeiChangeHTML',
            className: "width170",
            sorter: (a, b) => (a.imeiChange || "").toString().localeCompare((b.imeiChange || "").toString()),
        },
        {
            title: 'Status Change',
            dataIndex: 'statusChangeHTML',
            className: "width140",
            sorter: (a, b) => (a.statusChange || "").toString().localeCompare((b.statusChange || "").toString()),
        },
    ],
    auditModuleActivitySummary: [
        {
            title: 'Module',
            dataIndex: 'moduleHTML',
            className: "width160",
            sorter: (a, b) => (a.module || "").toString().localeCompare((b.module || "").toString()),
        },
        {
            title: 'Total Activities',
            dataIndex: 'totalActivitiesHTML',
            className: "width140 textCenter",
            sorter: (a, b) => (a.totalActivities || 0) - (b.totalActivities || 0),
        },
        {
            title: 'Most Common Activity',
            dataIndex: 'mostCommonActivity',
            className: "width220",
            sorter: (a, b) => (a.mostCommonActivity || "").toString().localeCompare((b.mostCommonActivity || "").toString()),
        },
        {
            title: 'Last Activity Time',
            dataIndex: 'lastActivityTime',
            className: "width160",
            sorter: (a, b) => (a.lastActivityTime || "").toString().localeCompare((b.lastActivityTime || "").toString()),
        },
        {
            title: 'Most Active Admin',
            dataIndex: 'mostActiveAdminHTML',
            className: "width180",
            sorter: (a, b) => (a.mostActiveAdmin || "").toString().localeCompare((b.mostActiveAdmin || "").toString()),
        },
    ],
    auditUserActivitySummary: [
        {
            title: 'Admin Name',
            dataIndex: 'userNameHTML',
            className: "width180",
            sorter: (a, b) => (a.userName || "").toString().localeCompare((b.userName || "").toString()),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            className: "width220",
            sorter: (a, b) => (a.email || "").toString().localeCompare((b.email || "").toString()),
        },
        {
            title: 'Sessions',
            dataIndex: 'sessions',
            className: "width100 textCenter",
            sorter: (a, b) => (a.sessions || 0) - (b.sessions || 0),
        },
        {
            title: 'Total Activities',
            dataIndex: 'totalActivitiesHTML',
            className: "width140 textCenter",
            sorter: (a, b) => (a.totalActivities || 0) - (b.totalActivities || 0),
        },
        {
            title: 'Profile Updates',
            dataIndex: 'profileUpdates',
            className: "width130 textCenter",
            sorter: (a, b) => (a.profileUpdates || 0) - (b.profileUpdates || 0),
        },
        {
            title: 'Reports Generated',
            dataIndex: 'reportsGenerated',
            className: "width150 textCenter",
            sorter: (a, b) => (a.reportsGenerated || 0) - (b.reportsGenerated || 0),
        },
        {
            title: 'Payment Activities',
            dataIndex: 'paymentActivities',
            className: "width150 textCenter",
            sorter: (a, b) => (a.paymentActivities || 0) - (b.paymentActivities || 0),
        },
        {
            title: 'Line Actions',
            dataIndex: 'lineActions',
            className: "width120 textCenter",
            sorter: (a, b) => (a.lineActions || 0) - (b.lineActions || 0),
        },
        {
            title: 'Last Login',
            dataIndex: 'lastLogin',
            className: "width160",
            sorter: (a, b) => (a.lastLogin || "").toString().localeCompare((b.lastLogin || "").toString()),
        },
    ],
    auditPaymentHistoryAudit: [
        {
            title: 'Date/Time',
            dataIndex: 'dateTime',
            className: "width140",
            sorter: (a, b) => (a.dateTime || "").toString().localeCompare((b.dateTime || "").toString()),
        },
        {
            title: 'Admin User',
            dataIndex: 'adminHTML',
            className: "width180",
            sorter: (a, b) => (a.admin || "").toString().localeCompare((b.admin || "").toString()),
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            className: "width180",
            sorter: (a, b) => (a.activity || "").toString().localeCompare((b.activity || "").toString()),
        },
        {
            title: 'Reference',
            dataIndex: 'refHTML',
            className: "width120",
            sorter: (a, b) => (a.ref || "").toString().localeCompare((b.ref || "").toString()),
        },
        {
            title: 'Amount / Detail',
            dataIndex: 'amountDetailHTML',
            className: "width240",
            sorter: (a, b) => (a.amountDetail || "").toString().localeCompare((b.amountDetail || "").toString()),
        },
    ],
    auditProfileActivityAudit: [
        {
            title: 'Date/Time',
            dataIndex: 'dateTime',
            className: "width140",
            sorter: (a, b) => (a.dateTime || "").toString().localeCompare((b.dateTime || "").toString()),
        },
        {
            title: 'Admin User',
            dataIndex: 'adminHTML',
            className: "width180",
            sorter: (a, b) => (a.admin || "").toString().localeCompare((b.admin || "").toString()),
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            className: "width180",
            sorter: (a, b) => (a.activity || "").toString().localeCompare((b.activity || "").toString()),
        },
        {
            title: 'Old Value',
            dataIndex: 'oldValueHTML',
            className: "width180",
            sorter: (a, b) => (a.oldValue || "").toString().localeCompare((b.oldValue || "").toString()),
        },
        {
            title: 'New Value',
            dataIndex: 'newValueHTML',
            className: "width180",
            sorter: (a, b) => (a.newValue || "").toString().localeCompare((b.newValue || "").toString()),
        },
    ],
    auditFullActivityLog: [
        {
            title: 'Date/Time',
            dataIndex: 'dateTime',
            className: "width140",
            sorter: (a, b) => (a.dateTime || "").toString().localeCompare((b.dateTime || "").toString()),
        },
        {
            title: 'Session ID',
            dataIndex: 'sessionIdHTML',
            className: "width150",
            sorter: (a, b) => (a.sessionId || "").toString().localeCompare((b.sessionId || "").toString()),
        },
        {
            title: 'Admin User',
            dataIndex: 'adminHTML',
            className: "width180",
            sorter: (a, b) => (a.admin || "").toString().localeCompare((b.admin || "").toString()),
        },
        {
            title: 'Module',
            dataIndex: 'module',
            className: "width140",
            sorter: (a, b) => (a.module || "").toString().localeCompare((b.module || "").toString()),
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            className: "width180",
            sorter: (a, b) => (a.activity || "").toString().localeCompare((b.activity || "").toString()),
        },
        {
            title: 'Details',
            dataIndex: 'detailsHTML',
            className: "width260",
            sorter: (a, b) => (a.details || "").toString().localeCompare((b.details || "").toString()),
        },
        {
            title: 'IP Address',
            dataIndex: 'ipAddressHTML',
            className: "width140",
            sorter: (a, b) => (a.ipAddress || "").toString().localeCompare((b.ipAddress || "").toString()),
        },
        {
            title: 'Status',
            dataIndex: 'statusHTML',
            className: "width120",
            sorter: (a, b) => (a.status || "").toString().localeCompare((b.status || "").toString()),
        },
    ],
}
